import type { ChangeEvent } from 'react';

import { Input } from '@/components/ui/input';

import type { QuestionRendererProps } from '../types';

export const EmailQuestion = ({
  question,
  value,
  onChange,
  onBlur,
  error,
  mode,
  disabled,
}: QuestionRendererProps<string>) => {
  if (question.type !== 'email') {
    return null;
  }

  const isInteractive = mode === 'runtime' && !disabled;
  const placeholder = question.placeholder || 'name@example.com';

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (!isInteractive) {
      return;
    }
    onChange?.(event.target.value);
  };

  return (
    <div className="space-y-1.5">
      <Input
        type="email"
        inputMode="email"
        autoComplete="email"
        value={value ?? ''}
        onChange={handleChange}
        onBlur={() => onBlur?.()}
        placeholder={placeholder}
        disabled={!isInteractive}
        aria-invalid={Boolean(error)}
        aria-describedby={`validation-${question.id}`}
        aria-errormessage={error ? `error-${question.id}` : undefined}
      />
      <p className="text-xs text-muted-foreground">Format: name@example.com</p>
    </div>
  );
};
